export default "__VITE_ASSET__S0WxSW$w__"